module.exports = __webpack_public_path__ + "img/Tessellate01.fd26b8e9.png";